import {
  differenceInMilliseconds,
  setDate,
  setHours,
  setMinutes,
  setSeconds
} from 'date-fns';
import type { ScheduleSolversTimeConfigType } from '../../types';

export const sameDayInMonthTime = ({
  startDate,
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = differenceInMilliseconds(endDate, startDate);

  const startDay = startDate.getDate();
  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();
  const startSeconds = startDate.getSeconds();

  const startDateInThisMonth = setSeconds(
    setMinutes(setHours(setDate(userDate, startDay), startHour), startMinutes),
    startSeconds
  );

  const endDateInThisMonth = new Date(
    startDateInThisMonth.getTime() + viewDuration
  );

  return endDateInThisMonth.getTime() - userDate.getTime();
};
